'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import { useAlertBanner, useScrollToSection } from '@libs/common-next';
import { AlertBanner } from './AlertBanner';
type AlertBannerContainerProps = {
  isChild?: boolean;
};
export function AlertBannerContainer(t0) {
  const $ = _c(9);
  const {
    isChild
  } = t0;
  const {
    alert,
    alertKey,
    childAlert
  } = useAlertBanner();
  const currentAlert = isChild ? childAlert : alert;
  const elementRef = useRef(null);
  const scrollToSection = useScrollToSection();
  let t1;
  if ($[0] !== alert?.skipScrollToAlert || $[1] !== scrollToSection) {
    t1 = () => {
      if (elementRef?.current && !alert?.skipScrollToAlert) {
        scrollToSection("alert-banner-container");
      }
    };
    $[0] = alert?.skipScrollToAlert;
    $[1] = scrollToSection;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== alert) {
    t2 = [alert];
    $[3] = alert;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== alertKey || $[6] !== currentAlert || $[7] !== isChild) {
    t3 = currentAlert ? <div ref={elementRef} className="alert-banner-container" id="alert-banner-container"><AlertBanner key={isChild ? undefined : alertKey} header={currentAlert.header} variant={currentAlert.variant} iconName={currentAlert?.icon} dismissible={currentAlert?.dismissible}>{currentAlert.text}</AlertBanner></div> : null;
    $[5] = alertKey;
    $[6] = currentAlert;
    $[7] = isChild;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}